<div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1050;">
  <div *ngFor="let toast of toastService.toasts()" [class]="'toast show ' + getToastClass(toast.type)" role="alert"
    aria-live="assertive" aria-atomic="true">
    <div class="toast-header">
      <span class="me-auto">
        {{toast.message}}

      </span>
      <!-- <small>11 mins ago</small> -->
      <button type="button" class="btn-close" (click)="toastService.removeToast(toast)" data-bs-dismiss="toast"
        aria-label="Close"></button>
    </div>
    <!-- <div class="toast-body">
      {{toast.message}}
    </div> -->
    <div class="progress">
      <div class="progress-bar" role="progressbar"></div>
    </div>
  </div>
</div>
